import { createContext, useContext } from "react";

type AuthWrapperContextValue = {
  setIsSigningIn: (value: boolean) => void;
};

export const AuthWrapperContext = createContext<AuthWrapperContextValue>({
  setIsSigningIn: () => {},
});

export const useAuthWrapper = () => useContext(AuthWrapperContext);
